import { application } from "./controllers/application"

import PieChartController from "./controllers/pie_chart_controller"
application.register("pie-chart", PieChartController)
